import { Component, OnInit } from '@angular/core';
import { BitfMatSidenavService } from '@bitf/core/services/sidenav/material/bitf-mat-sidenav.service';
import { EBitfOnlineStates, EBitfSidenavMode, EBitfSidenavPosition } from '@common/enums';
import { BitfPwaService } from '@common/libs/bitforce/core/services/pwa/bitf-pwa.service';
import { SidenavMenuComponent } from '../sidenav-menu/sidenav-menu.component';

import { StoreService } from '@services';

@Component({
  selector: 'soh-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  eBitfOnlineStates = EBitfOnlineStates;

  constructor(
    private bitfMatSidenavService: BitfMatSidenavService,
    public bitfPwaService: BitfPwaService,
    public storeService: StoreService
  ) {}

  ngOnInit(): void {}

  openMenu() {
    this.bitfMatSidenavService.open({
      component: SidenavMenuComponent,
      sidenavOptions: {
        mode: EBitfSidenavMode.OVER,
        position: EBitfSidenavPosition.START,
        disableClose: false,
      },
    });
  }
}
